// extracted by mini-css-extract-plugin
export default {"root":"HasSubscriptionInformer__root--20qum","button":"HasSubscriptionInformer__button--2_Nlh","text":"HasSubscriptionInformer__text--2yTP1"};